module.exports = __webpack_public_path__ + "img/myCard1.7cad862f.jpg";